import type { PieceJointeContentProps } from "../../lib/types";
import { cn } from "@repo/utils";

export default function DevisConstructionAtelierProductionPJ({
  variablesData,
}: PieceJointeContentProps) {
  return (
    <>
      <div className={cn("flex items-center justify-between")}>
        <div className={cn("flex w-[10rem] flex-col")}>
          <img
            src="/logos/lecco.png"
            alt="logo_sytel_grand_est"
            height={150}
            width={150}
          />
          <div className={cn("text-center text-xs")}>
            999 Chemin DES DUCS 57000 METZ
          </div>
        </div>
        <div className={cn("mr-36 font-bold underline")}>DEVIS n°225</div>
      </div>
      <div className={cn("flex flex-col")}>
        <div>
          NOM DU DEMANDEUR : <span>{variablesData.societe_nom} NANCY</span>
        </div>
        <div>
          OBJET : <span>ATELIER DE PRODUCTION</span>
        </div>

        <div className={cn("my-4 h-[1px] w-full bg-black")}></div>

        <div className={cn("font-bold")}>{`COUT DE LA MAIN D'OEUVRE :`}</div>
        <table>
          <tbody className={cn("text-sm")}>
            <tr>
              <td className={cn("w-48")}>Menuisier</td>
              <td className={cn("w-48 text-right")}>8 jours x 8 heures</td>
              <td className={cn("w-48 text-right")}>19 euros/H</td>
              <td className={cn("w-48 text-right")}>1 216 euros</td>
            </tr>
            <tr>
              <td>Manoeuvre</td>
              <td className={cn("text-right")}>30 jours x 8 heures</td>
              <td className={cn("text-right")}>15 euros/H</td>
              <td className={cn("text-right")}>3 600 euros</td>
            </tr>
            <tr>
              <td>Electricien</td>
              <td className={cn("text-right")}>6 jours x 8 heures</td>
              <td className={cn("text-right")}>19 euros/H</td>
              <td className={cn("text-right")}>912 euros</td>
            </tr>
            <tr>
              <td>Plombier</td>
              <td className={cn("text-right")}>3 jours x 8 heures</td>
              <td className={cn("text-right")}>24 euros/H</td>
              <td className={cn("text-right")}>576 euros</td>
            </tr>
            <tr>
              <td className={cn("font-bold")}>SOUS TOTAL HT</td>
              <td></td>
              <td></td>
              <td className={cn("text-right font-bold")}>6 304 euros</td>
            </tr>
          </tbody>
        </table>

        <div className={cn("my-4 h-[1px] w-full bg-black")}></div>

        <div className={cn("font-bold")}>{`COUT DE LA CONSTRUCTION :`}</div>
        <table>
          <tbody className={cn("text-sm")}>
            <tr>
              <td className={cn("w-96")}>Solage</td>
              <td className={cn("w-48")}></td>
              <td className={cn("w-48 text-right")}>6 100 euros</td>
            </tr>
            <tr>
              <td>Coùt de la structure préfabriquée</td>
              <td></td>
              <td className={cn("text-right")}>17 480 euros</td>
            </tr>
            <tr>
              <td>Matériel électrique</td>
              <td></td>
              <td className={cn("text-right")}>3 600 euros</td>
            </tr>
            <tr>
              <td>Matériel de plomberie</td>
              <td></td>
              <td className={cn("text-right")}>1 400 euros</td>
            </tr>
            <tr>
              <td>Matériel de finition</td>
              <td></td>
              <td className={cn("text-right")}>2 200 euros</td>
            </tr>
            <tr>
              <td className={cn("font-bold")}>SOUS TOTAL HT</td>
              <td></td>
              <td className={cn("text-right font-bold")}>30 780 euros</td>
            </tr>
          </tbody>
        </table>

        <div className={cn("my-4 h-[1px] w-full bg-black")}></div>

        <table>
          <tbody className={cn("text-sm")}>
            <tr>
              <td className={cn("w-96 font-bold")}>TOTAL HT</td>
              <td className={cn("w-48")}></td>
              <td className={cn("w-48 text-right font-bold")}>37 084 euros</td>
            </tr>
            <tr>
              <td>TVA (20%)</td>
              <td></td>
              <td className={cn("text-right")}>7 412 euros</td>
            </tr>
            <tr>
              <td>{`COUT TOTAL DE L'ATELIER DE PRODUCTION T.T.C.`}</td>
              <td></td>
              <td className={cn("text-right")}>44 496 euros</td>
            </tr>
          </tbody>
        </table>

        <div className={cn("my-4 h-[1px] w-full bg-black")}></div>

        <div
          className={cn("font-bold")}
        >{`SELON LES CONDITIONS SUIVANTES :`}</div>
        <ul className={cn("list-disc pl-12 text-sm")}>
          <li>{`Temps d'exécution des travaux: 90 jours`}</li>
          <li>
            Au prix horaire moyen de 20 euros/Homme + coùt de matériaux,
            fournitures, etc
          </li>
          <li>Prix révisable après 40 jours</li>
        </ul>

        <div className={cn("my-4 h-[1px] w-full bg-black")}></div>

        <table>
          <tbody className={cn("text-center text-sm")}>
            <tr>
              <td className={cn("w-64")}>ESTIME PAR</td>
              <td className={cn("w-64")}>APPROUVE PAR</td>
              <td className={cn("w-64")}>APPROUVE PAR</td>
            </tr>
            <tr>
              <td className={cn("font-bold")}>B. DUNAUD</td>
              <td className={cn("font-bold")}>S. PAUL (Chef de Section)</td>
              <td className={cn("font-bold")}>
                R. {variablesData.lecco_gerant_nom} (Gérant)
              </td>
            </tr>
          </tbody>
        </table>

        <div className={cn("my-4 h-[1px] w-full bg-black")}></div>

        <div className={cn("text-sm")}>
          CONSERVER LA COPIE DEMANDEUR ET RETOURNER LA COPIE SOUMISSIONNAIRE
          AVEC VOTRE APPROBATION POUR EXECUTION DES TRAVAUX
        </div>

        <div className={cn("my-4 h-[1px] w-full bg-black")}></div>

        <div className={cn("text-sm")}>
          APPROBATION DU DEMANDEUR (avec mention manuscrite :{" "}
          {`"Approbation pour
          exécution des travaux"`}
          )
        </div>
        <div className={cn("self-end pr-20 pt-6")}>
          <img
            src="/images_pj/signature_devis_atelier_production.png"
            alt="signature"
            width={400}
            height={100}
          />
        </div>
      </div>
    </>
  );
}

DevisConstructionAtelierProductionPJ.title = "Devis Lecco Construction";
